import React from 'react';
import './UISectionTitle.scss';

export interface UISectionTitleProps {
  /**
   * Основний заголовок секції
   */
  title: string;

  /**
   * Опис під заголовком (опціонально)
   */
  description?: string;

  /**
   * Елемент дії справа (кнопка, іконка, тощо)
   */
  action?: React.ReactNode;

  /**
   * Показувати розділювач під текстом
   */
  showDivider?: boolean;

  /**
   * Розмір компонента
   */
  size?: 'small' | 'medium' | 'large';

  /**
   * Варіант кольору заголовка
   */
  variant?: 'default' | 'primary' | 'secondary';

  /**
   * Вирівнювання тексту
   */
  align?: 'left' | 'center';

  /**
   * Компактний варіант (менший gap)
   */
  compact?: boolean;

  /**
   * Додатковий CSS клас
   */
  className?: string;

  /**
   * HTML тег для заголовка (семантика)
   */
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

// Моковые данные для демонстрації
const mockProps: UISectionTitleProps = {
  title: 'Personal information',
  description: 'Update some personal information. Your address will never be publicly available.',
  showDivider: true,
  size: 'medium',
  variant: 'default',
  align: 'left',
  compact: false,
  as: 'h2',
};

const baseClass = 'UISectionTitle';

const UISectionTitle: React.FC<UISectionTitleProps> = ({
                                                         title = mockProps.title,
                                                         description = mockProps.description,
                                                         action,
                                                         showDivider = mockProps.showDivider,
                                                         size = mockProps.size,
                                                         variant = mockProps.variant,
                                                         align = mockProps.align,
                                                         compact = mockProps.compact,
                                                         className = '',
                                                         as = mockProps.as,
                                                       }) => {
  const containerClasses = [
    baseClass,
    `${baseClass}--${size}`,
    variant !== 'default' && `${baseClass}--${variant}`,
    align === 'center' && `${baseClass}--center`,
    compact && `${baseClass}--compact`,
    !showDivider && `${baseClass}--no-divider`,
    action && `${baseClass}--with-action`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  // Динамічний тег для заголовка
  const TitleTag = as as keyof JSX.IntrinsicElements;

  return (
    <div className={containerClasses}>
      <div className={`${baseClass}__content`}>
        <div className={`${baseClass}__text`}>
          <TitleTag className={`${baseClass}__title`}>
            {title}
          </TitleTag>

          {description && (
            <p className={`${baseClass}__description`}>
              {description}
            </p>
          )}
        </div>

        {action && (
          <div className={`${baseClass}__action`}>
            {action}
          </div>
        )}
      </div>

      {showDivider && <hr className={`${baseClass}__divider`} />}
    </div>
  );
};

export default UISectionTitle;